import api from '@/api/API';
import {
  DetailedEmailCampaign, ExternalCampaign,
  ExternalCampaignFilters,
  ListCustomFieldsFilters,
  QueryFilters,
  QueryResult,
} from '@/types';

export default {
  find(id: string): Promise<DetailedEmailCampaign> {
    return api
      .get(`email-campaigns/${id}`)
      .then(response => response.data);
  },
  findAll(clientId: string, filters: QueryFilters): Promise<QueryResult> {
    return api
      .get(`clients/${clientId}/email-campaigns`, { params: filters })
      .then(response => response.data);
  },
  findExternalCampaigns(clientId, filters: ExternalCampaignFilters): Promise<ExternalCampaign[]> {
    return api
      .get(`clients/${clientId}/external-campaigns`, { params: filters })
      .then(response => response.data);
  },
  findListCustomFields(
    clientId: string, filters: ListCustomFieldsFilters,
  ): Promise<QueryResult[]> {
    return api
      .get(`clients/${clientId}/custom-fields`, {
        params: filters,
      })
      .then(response => response.data);
  },
};
